import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { DependencyList, Ref, RefObject, useRef } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

gsap.registerPlugin(ScrollTrigger)

interface ScrollTriggerParams extends gsap.plugins.ScrollTriggerStaticVars {
  endTriggerRef?: RefObject<any>
  pinRef?: RefObject<any>
  scrollerRef?: RefObject<any>
}

/**
 * GSAP scrollTrigger hooks to animation objects from scroll value
 * @param ref
 * @param params
 * @param deps
 * @returns scrollTriggerInstance
 */
function useScrollTrigger(
  ref: RefObject<any>,
  params: ScrollTriggerParams = {},
  deps: DependencyList = [],
) {
  const scrollTrigger = useRef<gsap.plugins.ScrollTriggerInstance>()

  useIsomorphicLayoutEffect(() => {
    scrollTrigger.current = ScrollTrigger.create({
      trigger: ref?.current,
      ...params,
      endTrigger: params?.endTriggerRef?.current ?? params?.endTrigger,
      pin: params?.pinRef?.current ?? params?.pin,
      scroller: params?.scrollerRef?.current ?? params?.scroller,
    })

    return () => {
      scrollTrigger.current.kill()
      scrollTrigger.current = null
    }
  }, [...deps])

  return scrollTrigger.current
}

export default useScrollTrigger
